import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-background" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-2.5 w-2.5 bg-primary block rotate-45" />
              <span className="font-display font-black text-lg tracking-tight uppercase">
                Fuze<span className="text-primary">Point</span>
              </span>
            </div>
            <p className="mt-6 max-w-sm text-foreground/50 leading-relaxed text-sm">
              Precision leadership training. We equip emerging leaders with the clarity, discipline,
              and resilience needed to thrive in complex environments.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-foreground/40 mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              <li><a href="#approach" className="text-foreground/70 hover:text-primary transition-colors">Approach</a></li>
              <li><a href="#services" className="text-foreground/70 hover:text-primary transition-colors">Services</a></li>
              <li><a href="#contact" className="text-foreground/70 hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-foreground/40 mb-5">Internal</p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/admin" data-testid="footer-admin-link" className="text-foreground/70 hover:text-primary transition-colors">
                  Admin
                </Link>
              </li>
              <li>
                <button
                  onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
                  data-testid="footer-cookie-link"
                  className="text-foreground/70 hover:text-primary transition-colors text-left"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-foreground/40">
            © {new Date().getFullYear()} FuzePoint Consulting
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-foreground/40">
            Defuse Challenges · Ignite Potential
          </p>
        </div>
      </div>
    </footer>
  );
}
